import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Element, isAuthenticated, loading, ...rest }) => {
    if (loading) return <div className="p-4">Checking session...</div>;
    return isAuthenticated ? <Element {...rest} /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
